import Protected from "@/pages/protected";
import { DataService } from "@/services/data";
import { Outlet, RouteObject, defer } from "react-router-dom";

const SelfRegistrationRoute: RouteObject = {
    path: "autonomes",
    element: (
        <Protected groups={["app_registration_admin"]}>
            <Outlet />
        </Protected>
    ),
    children: [
        {
            index: true,
            async lazy() {
                let { ListPage } = await import("@/pages/registration/self_registration/list");
                return { Component: ListPage };
            },
            loader: async ({ request }) => {
                const url = new URL(request.url);
                url.searchParams.set("registration_type", "SelfRegistration");
                if (!url.searchParams.has("page_size")) {
                    url.searchParams.set("page_size", "25");
                }
                const registrations = DataService.client
                    .url(`/registration/admin/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                    .get()
                    .json();
                return defer({ registrations });
            }
        }
    ]
};
export default SelfRegistrationRoute;
